import React, { useEffect, useState } from "react";
import axios from "axios";
import PaginatedTable from '../components/paginatedTable';
import { useNavigate } from "react-router-dom";
import { GridActionsCellItem, GridRowModes } from "@mui/x-data-grid";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import DeleteTemplateDialog from "../components/adminStartupDetails/dialogs/deleteTemplateDialog";
import StandardButton from "../components/standardButton";

export default function InboxMessages() {
  const [rows, setRows] = useState([]);
  const [rowModesModel, setRowModesModel] = useState({});

  const navigate = useNavigate();

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const fetchTemplates = async () => {
    try {
      const tokenFromStorage = localStorage.getItem("token");
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/templates`, {
        params: { page: 1 },
        headers: {
          Authorization: `Bearer ${tokenFromStorage}`
        }
      });

      const formattedData = response.data.data.map((template) => ({
        id: template.id,
        name: template.name,
        lastMessage: template.subject || "—",
        timingName: template.timing?.name || "—",
        date: "—"
      }));

      setRows(formattedData);
    } catch (error) {
      console.error("Failed to fetch templates:", error);
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  const openDialog = (id) => {
    setSelectedId(id);
    setOpenDeleteDialog(true);
  };

  const closeDialog = () => {
    setOpenDeleteDialog(false);
    setSelectedId(null);
  };

  const confirmDelete = async (id) => {
    try {
      const tokenFromStorage = localStorage.getItem("token");
      await axios.delete(`${process.env.REACT_APP_API_URL}/templates/${id}`, {
        headers: { Authorization: `Bearer ${tokenFromStorage}` }
      });

      // Ricarica i dati aggiornati
      await fetchTemplates();

      closeDialog();
    } catch (err) {
      console.error("Error deleting template", err);
    }
  };


  const header = [
    { field: 'id', headerName: 'Id', width: 100 },
    { field: 'name', headerName: 'Name', width: 350 },
    { field: 'lastMessage', headerName: 'Subject', width: 500 },
    { field: 'timingName', headerName: 'Timing', width: 350 },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      width: 100,
      cellClassName: 'actions',
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              sx={{ color: 'primary.main' }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              onClick={handleCancelClick(id)}
              color="inherit"
            />
          ];
        }

        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
          />
        ];
      }
    }
  ];

  const handleEditClick = (id) => () => {
    navigate(`/inbox-messages/${id}`);
  };

  const handleSaveClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleDeleteClick = (id) => () => {
    openDialog(id);
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.id === id);
    if (editedRow?.isNew) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  return (
  <div className="p-5 flex justify-center items-center h-full max-h-[100vh]">
    <div className="p-5 flex items-center justify-center w-full h-full max-h-full bg-[#191919] rounded-2xl">
      <div className="flex flex-col gap-5 max-w-full max-h-full w-full h-full">
        <div className="flex justify-between items-center w-full">
          <h1 className="text-6xl font-medium">Notifications</h1>
            <div className="flex flex-row gap-5">
              <StandardButton text={"Add new email"} onClick={() => navigate("/inbox-messages/new")} width={"300px"} />              
            </div>
        </div>
        <PaginatedTable header={header} items={rows} hideFooterPagination={true}/>
      </div>
    </div>

    <DeleteTemplateDialog
      open={openDeleteDialog}
      handleClose={closeDialog}
      id={selectedId}
      handleConfirm={confirmDelete}
    />
  </div>
);


}
